import { useSnackbar } from 'notistack';
import { useQuery } from '@tanstack/react-query';
import { ENV } from '../constants';
import { authenticatedGet } from './authenticatedFetch';

export default function useUser(id) {
  const { enqueueSnackbar } = useSnackbar();

  return useQuery({
    queryKey: ['user', id],
    enabled: Boolean(id),
    queryFn: async () => {
      const response = await authenticatedGet(`${ENV.API_URL}/user/${id}`);

      if (!response.ok) {
        throw Error('Error retrieving user data');
      }

      const result = await response.json();

      return result.user;
    },
    onError(error) {
      enqueueSnackbar(error?.message || 'Error retrieving user data', {
        variant: 'error',
      });
    },
  });
}
